'use client';

import { Skeleton } from '@heroui/react';
import Col from '@/components/Layout/Flex/Col';
import Row from '@/components/Layout/Flex/Row';

export default function RescueLoadingSkeleton() {
  return (
    <Col className="w-full max-w-6xl mx-auto gap-8">
      {/* Hero skeleton */}
      <div className="relative w-full h-64 rounded-2xl overflow-hidden">
        <Skeleton className="w-full h-full" />
      </div>

      {/* Stats skeleton */}
      <Row className="justify-center gap-4 flex-wrap">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="w-32 h-24 rounded-xl" />
        ))}
      </Row>

      {/* Protocol cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Skeleton key={i} className="h-72 rounded-xl" />
        ))}
      </div>
    </Col>
  );
}
